import { Mutation } from '@apollo/client/react/components';
import type { MutationFunction as MutationFn } from '@apollo/client/react/types/types';
import * as React from 'react';
import GroupOptionsCheckbox from '../GroupOptionsCheckbox';
import SET_CLASS_VISIBILITY_MUTATION from './SET_CLASS_VISIBILITY_MUTATION.gql';
import ToastActions from 'actions/ToastActions';
import { ApolloError } from '@apollo/client';
import {
  setClassVisibility,
  setClassVisibilityVariables,
} from './__generated__/setClassVisibility';

export type SetClassVisibilityMutationFn = MutationFn<
  setClassVisibility,
  setClassVisibilityVariables
>;

type Props = {
  checked: boolean;
  classSearchabilitySchoolDefault: string;
  onChange: (event: React.MouseEvent, setClassVisibility: SetClassVisibilityMutationFn) => void;
  disabled: boolean;
};

const ClassSearchabilityCheckbox = ({
  checked,
  classSearchabilitySchoolDefault,
  onChange,
  disabled,
}: Props) => {
  return (
    <Mutation<setClassVisibility, setClassVisibilityVariables>
      mutation={SET_CLASS_VISIBILITY_MUTATION}
      onCompleted={() => ToastActions.showSuccessToast('Saved')}
      onError={(error: ApolloError) => ToastActions.showErrorToast(error.message)}
    >
      {(setClassVisibilityMutation) => (
        <GroupOptionsCheckbox
          label="Class visibility"
          sublabel="This class will appear in class search and on your profile."
          checked={checked}
          schoolDefault={classSearchabilitySchoolDefault}
          onChange={(event) => onChange(event, setClassVisibilityMutation)}
          disabled={disabled}
        />
      )}
    </Mutation>
  );
};

export default ClassSearchabilityCheckbox;
